const getTextColors = () => {
  return {
    light: {
      default: 'white',
      _dark: 'gray.800',
    },
    dark: {
      default: 'gray.800',
      _dark: 'white',
    },
  }
}

export default getTextColors()
